import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { default as GraphemeSplitter } from 'grapheme-splitter'
import { Keyboard } from '../components/keyboard/Keyboard'
import { CurrentRow } from '../components/grid/CurrentRow'
import { isWordInWordList, unicodeLength } from '../lib/words'
import { MAX_WORD_LENGTH } from '../constants/settings'

const DictionaryPage = () => {
  const navigate = useNavigate()
  const [currentWord, setCurrentWord] = useState('')
  const [enterPressed, setEnterPressed] = useState(false)

  const wordLength = unicodeLength(currentWord)

  const onChar = useCallback((value: string) => {
    setEnterPressed(false)
    setCurrentWord((prev) => {
      if (unicodeLength(prev) < MAX_WORD_LENGTH) {
        return prev + value
      }
      return prev
    })
  }, [])

  const onDelete = useCallback(() => {
    setEnterPressed(false)
    setCurrentWord((prev) =>
      new GraphemeSplitter().splitGraphemes(prev).slice(0, -1).join('')
    )
  }, [])

  const onEnter = useCallback(() => {
    setEnterPressed(true)
  }, [])

  let resultMessage: string | null = null
  let resultColor = ''

  if (wordLength === MAX_WORD_LENGTH) {
    if (isWordInWordList(currentWord)) {
      resultMessage = `«${currentWord}» բառը բառացանկին մէջ կայ`
      resultColor = 'text-green-600 dark:text-green-400'
    } else {
      resultMessage = `«${currentWord}» բառը բառացանկին մէջ չկայ`
      resultColor = 'text-red-600 dark:text-red-400'
    }
  } else if (enterPressed && wordLength !== MAX_WORD_LENGTH) {
    resultMessage = 'Բառը պէտք է ունենայ 5 տառ'
    resultColor = 'text-slate-500 dark:text-slate-400'
  }

  return (
    <div className="flex h-full flex-col">
      <div className="navbar">
        <div className="navbar-content px-5 short:h-auto relative">
          <button
            onClick={() => navigate('/')}
            className="cursor-pointer dark:text-white"
            aria-label="Back to game"
          >
            ←
          </button>
          <p className="text-xl font-bold dark:text-white absolute left-1/2 -translate-x-1/2">Բառիկ Բառարան</p>
        </div>
      </div>
      <div className="mx-auto flex w-full grow flex-col items-center px-1 pt-6 pb-8 sm:px-6 md:max-w-7xl lg:px-8">
        <div className="mb-4">
          <CurrentRow guess={currentWord} className="" />
        </div>
        {resultMessage && (
          <p className={`text-base font-semibold mb-4 ${resultColor}`}>
            {resultMessage}
          </p>
        )}
        <Keyboard
          onChar={onChar}
          onDelete={onDelete}
          onEnter={onEnter}
          guesses={[]}
        />
      </div>
    </div>
  )
}

export default DictionaryPage
